(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('ja')) return;

  // Store-owned wording for the native Judge.me popup; preserve its inputs,
  // validation and accessible label/help associations when it renders again.
  const copy = [
    ['#jdgm-email-help', 'ご投稿とご購入の確認後、担当者が15%OFFクーポンをこちらのメールアドレスにお送りします（自動送信ではありません）。メールアドレスは公開されません。'],
    ['label[for="jdgm-review-body-input"]', '商品を使った感想（必須）'],
    ['label[for="jdgm-email-input"]', 'メールアドレス（必須）'],
    ['label[for="jdgm-name-input"]', '表示名（必須・ニックネーム可）'],
  ];

  const modalSelector = '.jdgm-write-review-modal--compact';
  const nameMessage = '表示名を入力してください（ニックネーム可）。';

  // Judge.me submits through its own button handler rather than a native form
  // submit, so `required` alone does not prevent an empty name reaching it.
  function guardName(event) {
    const modal = event.target.closest?.(modalSelector);
    if (!modal?.querySelector('.jdgm-write-review-modal__compact-body.is-active')) return;
    const next = event.target.closest('.jdgm-write-review-modal__nav-btn-next');
    const enter = event.type === 'keydown' && event.key === 'Enter' && !event.isComposing
      && event.target.matches('#jdgm-name-input, #jdgm-email-input');
    if (!(event.type === 'click' && next) && !enter && event.type !== 'submit') return;
    const name = modal.querySelector('#jdgm-name-input');
    if (!name || name.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    name.setAttribute('aria-invalid', 'true');
    const error = modal.querySelector('#jdgm-name-error');
    if (error) {
      error.textContent = nameMessage;
      error.style.display = 'block';
      error.setAttribute('role', 'alert');
    }
    name.focus({ preventScroll: true });
    name.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  }
  ['click', 'keydown', 'submit'].forEach(type => document.addEventListener(type, guardName, true));
  document.addEventListener('input', (event) => {
    if (!event.target.matches?.(`${modalSelector} #jdgm-name-input`) || !event.target.value.trim()) return;
    event.target.removeAttribute('aria-invalid');
    const error = event.target.closest(modalSelector).querySelector('#jdgm-name-error');
    if (error?.textContent === nameMessage) { error.textContent = ''; error.style.display = 'none'; }
  });

  const scrollBodies = new WeakSet();
  function updateScrollHint(body, hint) {
    const remaining = body.scrollHeight - body.clientHeight - body.scrollTop;
    hint.hidden = body.clientHeight === 0 || remaining < 12;
  }

  function updateReviewCopy() {
    document.querySelectorAll('.jdgm-write-review-modal').forEach((form) => {
      copy.forEach(([selector, text]) => {
        const element = form.querySelector(selector);
        if (element && element.textContent.trim() !== text) element.textContent = text;
      });
      const comment = form.querySelector('#jdgm-review-body-input');
      const placeholder = 'どんな練習に使いましたか？良かった点や気になった点を教えてください。';
      if (comment && comment.getAttribute('placeholder') !== placeholder) comment.setAttribute('placeholder', placeholder);
      const body = form.querySelector('.jdgm-write-review-modal__compact-body');
      const anonymous = form.querySelector('#jdgm-anonymous-checkbox');
      // Retain the native control internally, resetting through its own handler.
      if (anonymous?.checked) anonymous.click();
      anonymous?.closest('.jdgm-write-review-modal__field-group')?.classList.add('mm-review-anonymous-hidden');
      const name = form.querySelector('#jdgm-name-input');
      if (name) {
        name.required = true;
        name.setAttribute('aria-required', 'true');
        // The native widget derives a display name from the email until this
        // flag is set. Require a deliberate name/nickname instead, and avoid
        // unintentionally publishing part of the customer's email address.
        if (name.getAttribute('data-manually-edited') === 'false') {
          name.value = '';
          name.setAttribute('data-manually-edited', 'true');
        }
      }

      const navigation = form.querySelector('.jdgm-write-review-modal__navigation');
      if (body && navigation) {
        let hint = navigation.querySelector('.mm-review-scroll-hint');
        if (!hint) {
          hint = document.createElement('button');
          hint.type = 'button';
          hint.className = 'mm-review-scroll-hint';
          hint.textContent = '下にスクロールして入力を続ける ↓';
          hint.addEventListener('click', () => body.scrollBy({ top: Math.max(120, body.clientHeight * 0.7), behavior: 'auto' }));
          navigation.prepend(hint);
        }
        if (!scrollBodies.has(body)) {
          scrollBodies.add(body);
          const update = () => updateScrollHint(body, hint);
          body.addEventListener('scroll', update, { passive: true });
          if (window.ResizeObserver) {
            const resize = new ResizeObserver(update);
            resize.observe(body);
            [...body.children].forEach(child => resize.observe(child));
          }
        }
        updateScrollHint(body, hint);
      }
      const media = body?.querySelector('.jdgm-write-review-modal__page--share-media');
      const about = body?.querySelector('.jdgm-write-review-modal__page--about-you');
      // Move the native upload page intact: retain its file input, handlers and
      // preview/delete controls, and keep keyboard order aligned with the UI.
      if (media && about && media.nextElementSibling !== about) body.insertBefore(media, about);
      const prompt = media?.querySelector('.jdgm-write-review-modal__media-upload-prompt');
      if (prompt && prompt.textContent !== '写真を追加（任意）') prompt.textContent = '写真を追加（任意）';
      const input = media?.querySelector('input[type="file"]');
      if (input && input.getAttribute('aria-label') !== '写真を追加（任意）') input.setAttribute('aria-label', '写真を追加（任意）');
    });
  }

  updateReviewCopy();
  new MutationObserver(updateReviewCopy).observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  const entry = document.querySelector('[data-mm-review-entry]');
  if (!entry || window.Shopify?.designMode) return;
  const status = entry.querySelector('[data-mm-review-entry-status]');
  const started = Date.now();
  // Judge.me loads asynchronously. Stop as soon as it opens, so dismissing the
  // form never reopens it; leave the native button available if loading fails.
  const launch = window.setInterval(() => {
    const modal = document.querySelector('.jdgm-write-review-modal');
    if (modal && getComputedStyle(modal).display !== 'none') {
      window.clearInterval(launch);
      status.hidden = true;
      return;
    }
    if (Date.now() - started > 15000) {
      window.clearInterval(launch);
      status.textContent = '下の「レビューを書く」から投稿できます。表示されない場合はページを再読み込みしてください。';
      return;
    }
    entry.querySelector('[data-testid="write-review-button"]')?.click();
  }, 250);
})();
